import { index as pricingIndex } from "@/routes/pricing";

export const isRefundedTreeRefusal = (error: unknown): boolean => {
  if (!error || typeof error !== "object" || !("response" in error)) {
    return false;
  }

  const response = error.response;

  if (
    !response ||
    typeof response !== "object" ||
    !("status" in response) ||
    response.status !== 403 ||
    !("data" in response)
  ) {
    return false;
  }

  const data = response.data;

  return Boolean(data && typeof data === "object" && "reason" in data && data.reason === "refunded_tree_capacity");
};

/** A fresh page drops the open tree and its in-memory queries before showing purchase recovery. */
export const redirectRefundedTreeRefusal = (error: unknown) => {
  if (isRefundedTreeRefusal(error)) {
    globalThis.location.assign(pricingIndex.url());
  }
};
